import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import { LanguageContext } from '../i18n/LanguageContext'
import Api from '../Services/Api'
import Loader from '../Library/Tools/Loader'
import LoadError from '../Components/LoadError'

function WithNavigate ({ Component, remount, loadById }) {
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams()
  const { language } = useContext(LanguageContext)
  const [document, setDocument] = useState(null)
  const [attempt, setAttempt] = useState(0)
  const id = loadById && params.id
  const source = id ? `/${loadById}/${id}` : null
  useEffect(() => {
    if (!source) return
    let active = true
    setDocument(null)
    Api.get(source).then(res => {
      if (!active) return
      const data = res.data?.data || res.data
      setDocument({ source, data: res.ok && data?._id ? data : null, status: res.status })
    }).catch(() => { if (active) setDocument({ source, data: null }) })
    return () => { active = false }
  }, [source, attempt])

  if (source && (!document || document.source !== source)) return <Loader loading />
  if (source && !document.data) return <LoadError missing={document.status === 404} onRetry={() => setAttempt(n => n + 1)} onBack={() => navigate(loadById === 'ordini' ? '/ordini' : `/${location.pathname.split('/')[1]}`)} />
  // A legacy edit URL without an id or navigation state must never create a blank document.
  if (!source && location.pathname.endsWith('/modifica') && !location.state) return <LoadError missing onBack={() => navigate(`/${location.pathname.split('/')[1]}`)} />
  const pageLocation = source ? { ...location, state: document.data } : location
  // remount: ogni navigazione (anche verso lo stesso path con un altro state) ricrea la pagina, che legge
  // location.state solo nel costruttore/componentDidMount; evita anche di riusare Nuovo* come Modifica*.
  return <Component key={remount || location.state?.fromSearch ? location.key : undefined} navigate={navigate} location={pageLocation} params={params} language={language} />
}

export default WithNavigate
